export default __webpack_public_path__ + "static/media/mars-city.dbcd0306.jpg";